/** Prefix for system internal adapter and instance ids */
export const SYSTEM_ADAPTER_PREFIX = 'system.adapter.';
/** Prefix for host object ids */
export const SYSTEM_HOST_PREFIX = 'system.host.';
/** The system repositories id */
export const SYSTEM_REPOSITORIES_ID = 'system.repositories';
/** The system config id */
export const SYSTEM_CONFIG_ID = 'system.config';
/** Unicode symbol to be appended on endkey of getObjectView */
export const HIGHEST_UNICODE_SYMBOL = '\u9999';
